import { useEffect, useRef } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { API_BASE_URL } from '../../api';

const socketUrl = `${API_BASE_URL}/ws`;

export default function NotificationSocket({ pharmacyId, onNotification }) {
  const onNotificationRef = useRef(onNotification);
  onNotificationRef.current = onNotification;

  useEffect(() => {
    // Wait for the pharmacy id (available once /api/auth/me resolves) — subscribing to a
    // pharmacy-scoped topic (see NotificationService.java) needs it, and connecting before
    // it's known would either fail to subscribe or require a reconnect once it arrives.
    if (!pharmacyId) return;

    const socket = new SockJS(socketUrl);
    const client = new Client({
      webSocketFactory: () => socket,
      reconnectDelay: 5000,
      onConnect: () => {
        client.subscribe(`/topic/notifications/${pharmacyId}`, (message) => {
          const notif = JSON.parse(message.body);
          onNotificationRef.current(notif);
        });
      },
    });

    client.activate();

    return () => client.deactivate();
  }, [pharmacyId]);

  return null;
}
